module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-48x48-17b7d44849984f506e2f93e8aaa3d150.png";